import * as React from "react";
import { Input as ShadcnInput } from "@/components/shadcn/input";
import { cn } from "@/lib/utils";

/**
 * Extended Input component with additional default styles and props.
 * Accepts all native input props and custom className.
 */
export interface InputProps extends React.ComponentProps<typeof ShadcnInput> {
  wrapperClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ wrapperClassName, className, ...props }, ref) => (
    <div className={cn("relative bg-white rounded-md", wrapperClassName)}>
      <ShadcnInput ref={ref} className={className} {...props} />
    </div>
  )
);
Input.displayName = "Input";
